/* Galaxy quick add (2026-10-04). Pairs with galaxy-product-card.css.

   1. "Choose options" on Dawn product cards (products with several variants)
      opens the product page. Dawn's own options pop-up is bypassed: it fetches
      the product page and reads Dawn's main-product markup, which our custom
      product section (galaxy-product) doesn't have, so it threw a null error
      and never opened. Johnson chose "go to the product page" on 2026-10-04;
      an in-card variant picker can come later if people use this a lot.

   2. Homepage cards (galaxy-bestsellers / galaxy-deals) get the same corner
      button. Those cards are one big <a>, and a button can't sit inside a
      link, so each card is rebuilt as a <div class="card"> whose title link
      stretches over the whole card (CSS ::after). Without JS the original
      links stay as they are, so nothing breaks.
      Whether a product has options is read from /products/<handle>.js the
      first time the card is pointed at, then cached.

   Desktop only: the CSS hides every corner button on phones and touch
   tablets, so none of this runs into a tap. */
(function () {
  if (window.__gxQuickAdd) return;
  window.__gxQuickAdd = 1;

  /* ---------- 1. Dawn cards: Choose options -> product page ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-card-wrapper modal-opener .quick-add__submit');
    if (!btn) return;
    var url = btn.getAttribute('data-product-url');
    if (!url) {
      var link = btn.closest('.product-card-wrapper').querySelector('a[href*="/products/"]');
      url = link && link.getAttribute('href');
    }
    if (!url) return; // leave Dawn to it
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
  }, true);

  function fixDawnLabels(root) {
    var list = (root || document).querySelectorAll('.product-card-wrapper modal-opener .quick-add__submit[aria-haspopup]');
    for (var i = 0; i < list.length; i++) list[i].removeAttribute('aria-haspopup');
  }

  /* ---------- 2. Homepage cards ---------- */
  var cache = {};
  function productJson(url) {
    var path = url.split('?')[0].replace(/\/$/, '');
    if (!cache[path]) {
      cache[path] = fetch(path + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (err) { delete cache[path]; throw err; });
    }
    return cache[path];
  }

  function setLabel(btn, text, title) {
    btn.querySelector('.gx-qadd__label').textContent = text;
    btn.setAttribute('aria-label', text + ': ' + title);
  }

  function hasOptions(p) {
    return p.variants && p.variants.length > 1;
  }

  function prime(card) {
    if (card.__gxPrimed) return;
    card.__gxPrimed = 1;
    var btn = card.querySelector('.gx-qadd');
    productJson(card.__gxUrl).then(function (p) {
      if (hasOptions(p)) setLabel(btn, 'Choose options', p.title);
    }).catch(function () {});
  }

  function rebuild(a) {
    if (a.__gxDone || !a.getAttribute('href')) return;
    var url = a.getAttribute('href');
    var card = document.createElement('div');
    for (var i = 0; i < a.attributes.length; i++) {
      var at = a.attributes[i];
      if (at.name !== 'href') card.setAttribute(at.name, at.value);
    }
    while (a.firstChild) card.appendChild(a.firstChild);
    card.__gxDone = 1;
    card.__gxUrl = url;

    var name = card.querySelector('.card-name');
    var title = name ? name.textContent.trim() : '';
    var link = document.createElement('a');
    link.className = 'card-link';
    link.href = url;
    if (name) {
      while (name.firstChild) link.appendChild(name.firstChild);
      name.appendChild(link);
    } else {
      link.setAttribute('aria-label', title || 'View product');
      card.appendChild(link);
    }

    var media = card.querySelector('.card-media') || card;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gx-qadd';
    btn.innerHTML = '<span class="gx-qadd__label" aria-hidden="true">Add to cart</span>';
    btn.setAttribute('aria-label', 'Add to cart: ' + title);
    media.appendChild(btn);

    a.parentNode.replaceChild(card, a);
    card.addEventListener('pointerenter', function () { prime(card); });
    card.addEventListener('focusin', function () { prime(card); });
  }

  function cartDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function addVariant(id) {
    var drawer = cartDrawer();
    var body = { id: id, quantity: 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || r.status);
        return data;
      });
    }).then(function (data) {
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gx-quick-add', productVariantId: id, cartData: data });
      }
      return drawer;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gx-qadd');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.card');
    var url = card && card.__gxUrl;
    if (!url || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    productJson(url).then(function (p) {
      if (hasOptions(p)) { window.location.href = url; return; }
      var v = p.variants && p.variants[0];
      if (!v) { window.location.href = url; return; }
      return addVariant(v.id).then(function (drawer) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        if (!drawer) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
    }).catch(function () {
      // Anything unexpected: the product page always works.
      window.location.href = url;
    });
  });

  function init() {
    fixDawnLabels(document);
    var cards = document.querySelectorAll('.ghome .cards > a.card, .ghome .cards .gcar > a.card');
    for (var i = 0; i < cards.length; i++) rebuild(cards[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  /* infinite scroll appends Dawn cards later */
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('modal-opener')) fixDawnLabels(e.target.closest('.product-card-wrapper'));
  });
})();
